import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from 'mdi-react/FacebookIcon';
import GooglePlusIcon from 'mdi-react/GooglePlusIcon';
import LogInForm from './components/LogInForm';

const LogIn = () => (
  <div className="account">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <h3 className="account__title">Welcome
            <span className="account__logo">  
              <span className="account__logo-accent"> </span>
            </span>
          </h3>
          <h4 className="account__subhead subhead"></h4>
        </div>
        <LogInForm onSubmit />
        <div className="account__or">
          <p></p>
        </div>
        <div className="account__social">
         
        </div>
      </div>
    </div>
  </div>
);

export default LogIn;
